export {default as BaseModal} from './BaseModal';
export {default as FormModal} from './FormModal';
export {default as ConfirmationModal} from './ConfirmationModal';
export {default as InfoModal} from './InfoModal';
export {default as GenericSettingsModal} from './GenericSettingsModal';

export type {
    BaseModalProps,
    FormModalProps,
    ConfirmationModalProps,
    InfoModalProps,
    GenericSettingsModalProps,
} from './types';
